import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'

interface NavBarContextValue {
  navBarHidden: boolean
  setNavBarHidden: (hidden: boolean) => void
}

const NavBarContext = createContext<NavBarContextValue>({
  navBarHidden: false,
  setNavBarHidden: () => {},
})

export function NavBarProvider({ children }: { children: ReactNode }) {
  const [navBarHidden, setNavBarHiddenState] = useState(false)
  const setNavBarHidden = useCallback((hidden: boolean) => {
    setNavBarHiddenState(hidden)
  }, [])

  return (
    <NavBarContext.Provider value={{ navBarHidden, setNavBarHidden }}>
      {children}
    </NavBarContext.Provider>
  )
}

export function useNavBar() {
  return useContext(NavBarContext)
}
